import { screeningsRoutes } from '@/backend/routes';
import { defaultCredentialingRoutes } from '@juvare/credentialing/backend/constants';
import { CredentialingConfig } from '@juvare/credentialing/backend/extraTypes';

export const credentialingConfig: CredentialingConfig = {
    credentialingRoutes: {
        ...defaultCredentialingRoutes,
        credentialVerifications: `${screeningsRoutes.root}/${screeningsRoutes.credentialVerifications}`,
    },
};
